import { PlainBtn, PrimaryBtn } from '@/buttons';
import { Children, Fragment, ReactNode, useRef } from 'react';

export const BookBtn = ({ className, children }: { className?: string; children?: ReactNode }) => {
    const widgetRef = useRef<HTMLDivElement>(null);

    const handleBookAppointmentClick = () => {
        if (widgetRef.current) {
            const chckupButton = widgetRef.current.querySelector('button');
            if (chckupButton) {
                chckupButton.click();
            } else {
                console.error('Chckup widget button not found.');
            }
        }
    };

    // temporary hiding
    return <Fragment />;

    return (
        <Fragment>
            <div ref={widgetRef} style={{ display: 'none' }}>
                <div
                    className="chckup_widget"
                    data-widget-id="6e85b697-b538-4bbd-9190-435750832a19"
                ></div>
            </div>
            {Children.count(children) ? (
                <PlainBtn onClick={handleBookAppointmentClick} className={className}>
                    {children}
                </PlainBtn>
            ) : (
                <PrimaryBtn onClick={handleBookAppointmentClick} className={className}>
                    Book Appointment
                </PrimaryBtn>
            )}
        </Fragment>
    );
};
